// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f2ad0","visible":"_29a35","content":"_112e4","talents":"_880c9","title":"_081eb","label":"_83110","buttons":"_4389c","button":"bcfe7"};